import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_2 = { class: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Item")
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "font-semibold text-gray-900" }
const _hoisted_6 = { class: "text-gray-600" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Price")
const _hoisted_8 = { class: "text-gray-600" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Status")
const _hoisted_10 = { class: "text-gray-500" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "py-8 text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 font-medium text-gray-900" }, " There are no items on hold ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-sm" }, " Future hold requests will show up here. ", -1)

import { useOrders } from "@/composables/orders";
import { computed, ref, Ref } from "vue";
import DefaultTable from "@/components/DefaultTable.vue";
import OrderStatusBadge from "@/components/OrderStatusBadge.vue";
import { formatDistanceToNow, parseISO } from "date-fns";
import {
  CheckIcon,
  ClipboardCheckIcon,
  ThumbUpIcon,
} from "@heroicons/vue/solid";
import TableSkeleton from "@/components/skeletons/TableSkeleton.vue";
import { useFulfilment } from "@/composables/fulfilment";
import { useVendor } from "@/composables/vendor";
import Spinner from "@/components/Spinner.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { orders: allOrders, isReady, isLoading, refresh } = useOrders();
const { client } = useFulfilment();
const { currentVendor } = useVendor();

const orders = computed(() =>
  allOrders.value.filter((val) => val.status === "HOLD")
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(isReady) || _unref(isLoading))
        ? (_openBlock(), _createBlock(TableSkeleton, { key: 0 }))
        : (_unref(orders).length > 0)
          ? (_openBlock(), _createBlock(DefaultTable, {
              key: 1,
              columns: ['name', 'cost', 'status', 'time'],
              rows: _unref(orders)
            }, {
              "th-name": _withCtx(() => [
                _hoisted_3
              ]),
              "td-name": _withCtx(({ row: order }) => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(order.name), 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(order.supplier) + " " + _toDisplayString(order.origin) + " " + _toDisplayString(order.supplierRef), 1)
                ])
              ]),
              "th-cost": _withCtx(() => [
                _hoisted_7
              ]),
              "td-cost": _withCtx(({ row: order }) => [
                _createElementVNode("span", _hoisted_8, " $" + _toDisplayString(order.costPriceUsd) + " USD ", 1)
              ]),
              "th-status": _withCtx(() => [
                _hoisted_9
              ]),
              "td-status": _withCtx(({ row: order }) => [
                _createVNode(OrderStatusBadge, {
                  value: order.status
                }, null, 8, ["value"])
              ]),
              "td-time": _withCtx(({ row: order }) => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatDistanceToNow)(_unref(parseISO)(order.updatedAt), {
                addSuffix: true,
              })), 1)
              ]),
              _: 1
            }, 8, ["rows"]))
          : (_unref(orders).length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(ThumbUpIcon), { class: "text-gray-400 w-8 h-8 block mx-auto" }),
                  _hoisted_13,
                  _hoisted_14
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})